import { Box, CircularProgress } from "@mui/material";
import { Navigate, Outlet, useLocation } from "react-router";

import { useAuth } from "./authContext";

/** 未登入導向登入頁，並記住原本想去的位置。 */
export function RequireAuth() {
  const { me, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <Box sx={{ display: "grid", placeItems: "center", minHeight: "100dvh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!me) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
